import { createSelector } from 'reselect';
const userStateSelector = (state) => state.user;
const userInfoStateSelector = createSelector(userStateSelector, (user) => user.info);
const loadUserInfoStateSelector = createSelector(userInfoStateSelector, (info) => info.loadUserInfo);
export const loadUserInfoSelector = createSelector(loadUserInfoStateSelector, (info) => info.userInfo);
export const loadUserInfoIsLoadingSelector = createSelector(loadUserInfoStateSelector, info => info.isLoading);
export const loadUserInfoErrorSelector = createSelector(loadUserInfoStateSelector, info => info.error);
const editUserInfoStateSelector = createSelector(userInfoStateSelector, (info) => info.editUserInfo);
export const editedUserInfoIdSelector = createSelector(editUserInfoStateSelector, (editUserInfo) => editUserInfo.editedUserId);
export const editUserInfoIsLoadingSelector = createSelector(editUserInfoStateSelector, editUserInfo => editUserInfo.isLoading);
export const editUserInfoErrorSelector = createSelector(editUserInfoStateSelector, editUserInfo => editUserInfo.error);
const editUserClientStateSelector = createSelector(userInfoStateSelector, (info) => info.editUserClient);
export const editUserClientSuccessSelector = createSelector(editUserClientStateSelector, (editUserClient) => editUserClient.success);
export const editUserClientIsLoadingSelector = createSelector(editUserClientStateSelector, editUserClient => editUserClient.isLoading);
export const editUserClientErrorSelector = createSelector(editUserClientStateSelector, editUserClient => editUserClient.error);
export const loadUserInfoGroupSelector = createSelector(loadUserInfoSelector, userInfo => userInfo ? userInfo.groups && userInfo.groups[0] : null);
const deleteUserInfoGroupStateSelector = createSelector(userInfoStateSelector, (info) => info.deleteUserInfoGroup);
export const deletedUserInfoGroupIdSelector = createSelector(deleteUserInfoGroupStateSelector, (deleteUserInfoGroup) => deleteUserInfoGroup.deletedUserGroupId);
export const deleteUserInfoGroupErrorSelector = createSelector(deleteUserInfoGroupStateSelector, (deleteUserInfoGroup) => deleteUserInfoGroup.error);
export const deleteUserInfoGroupIsLoadingSelector = createSelector(deleteUserInfoGroupStateSelector, (deleteUserInfoGroup) => deleteUserInfoGroup.isLoading);
const deleteUserInfoClientStateSelector = createSelector(userInfoStateSelector, (info) => info.deleteUserInfoClient);
export const deletedUserInfoClientIdSelector = createSelector(deleteUserInfoClientStateSelector, (deleteUserInfoClient) => deleteUserInfoClient.deletedUserClientId);
export const deleteUserInfoClientErrorSelector = createSelector(deleteUserInfoClientStateSelector, (deleteUserInfoClient) => deleteUserInfoClient.error);
export const deleteUserInfoClientIsLoadingSelector = createSelector(deleteUserInfoClientStateSelector, (deleteUserInfoClient) => deleteUserInfoClient.isLoading);
const deleteUserStateSelector = createSelector(userInfoStateSelector, (info) => info.deleteUser);
export const deletedUserIdSelector = createSelector(deleteUserStateSelector, (deleteUser) => deleteUser.deletedUserId);
export const deleteUserErrorSelector = createSelector(deleteUserStateSelector, (deleteUser) => deleteUser.error);
export const deleteUserIsLoadingSelector = createSelector(deleteUserStateSelector, (deleteUser) => deleteUser.isLoading);
export default {
    loadUserInfoSelector,
    loadUserInfoErrorSelector,
    loadUserInfoIsLoadingSelector,
    loadUserInfoGroupSelector,
    editedUserInfoIdSelector,
    editUserInfoErrorSelector,
    editUserInfoIsLoadingSelector,
    editUserClientSuccessSelector,
    editUserClientErrorSelector,
    editUserClientIsLoadingSelector,
    deletedUserInfoGroupIdSelector,
    deleteUserInfoGroupErrorSelector,
    deleteUserInfoGroupIsLoadingSelector,
    deletedUserInfoClientIdSelector,
    deleteUserInfoClientErrorSelector,
    deleteUserInfoClientIsLoadingSelector,
    deletedUserIdSelector,
    deleteUserErrorSelector,
    deleteUserIsLoadingSelector,
};
